import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { LogoWhite } from '../Logo/Logo';
import HeaderMainProtected from '../Header/HeaderMainProtected';
import FooterEnd from '../Footer/FooterEnd';


export default function PageProtected2ColTop({leftsideimage, brandtext, headline, formcomp, content }) {

return (
<>

 <Grid container sx={{ minWidth: '100%', minHeight: '100vh'}}>
      
          {/* LEFT SIDE */}      

            <Grid size={{xs:12,}} sx={{
              position: 'relative',
              backgroundImage: `url(${leftsideimage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'white',
              p: 8,
            }}> 
            
            {/* semi-transparent dark overlay for better readability*/}
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay
              //backdropFilter: 'blur(4px)', // <-- the blur!
              zIndex: 1,
            }}
          />

      {/* Logo at top-left */}
      <Box sx={{position: 'absolute', zIndex: 2, my:-1, top: { xs: 32, }, left: { xs: 32, lg: 64 }, }}> {<LogoWhite /> }</Box>


        {/* Bottom-left text */}
          <Box sx={{ position: 'absolute', zIndex: 2, bottom: { xs: 32, }, left: { xs: 32, lg: 64 }, pr: 4, maxWidth: '80%',}}>
            <Typography variant="h2">
              {brandtext}
            </Typography>
        </Box>
        </Grid>

   {/* RIGHT SIDE */}

   
      
      <Grid  size={12}
        sx={{ 
            display:'flex', 
            justifyContent:'center', 
            alignItems: { xs: 'flex-start' },          
            px: { xs: 2,  },
            py: { xs: 4,  }, // Padding top/bottom on mobile, center on desktop
            minHeight: '100vh',
            }}
            >
          <Grid container> 
            
            <Grid size={12} sx={{mt:4}}>  <HeaderMainProtected headline={headline} specify="" />   </Grid>
            
            <Grid size={12}> {content}  </Grid>
            
            
            <Grid size={12} sx={{width: '100%', maxWidth: {xs:320, lg:400}, textAlign: 'center',}}>
                  <Box sx={{ mt: 4 }}>{formcomp}</Box>
            </Grid>
        
        </Grid>

      </Grid>

</Grid>



   {/* FOOTER */}
<FooterEnd />

 </>
  )
}